import normalizeColor from "@tamagui/normalize-css-color";
const processColor = (color) => {
  if (color === void 0 || color === null) {
    return color;
  }
  let int32Color = normalizeColor(color);
  if (int32Color === void 0 || int32Color === null) {
    return void 0;
  }
  int32Color = (int32Color << 24 | int32Color >>> 8) >>> 0;
  return int32Color;
};
export {
  processColor
};
//# sourceMappingURL=index.js.map
